module.exports = __webpack_public_path__ + "resources/img/lan-en.c50b8c3c.png";